// Çizim editöründe paydaş notlarını gizleme/gösterme filtresi.
//   - LayerMenu UI bu filtreyi okur/yazar.
//   - useCalloutSync ve sahnede callout ekleyen diğer kodlar
//     `applyAuthorFilterToScene` ile filtreyi uygular.
// Module-level singleton — Redux yerine basit pub/sub.

const state = {
  hiddenAuthors: new Set(),
  listeners: new Set(),
};

export function getHiddenAuthors() {
  return state.hiddenAuthors;
}

export function setHiddenAuthors(setOrArray) {
  state.hiddenAuthors = new Set(setOrArray || []);
  for (const fn of state.listeners) {
    try { fn(state.hiddenAuthors); } catch (_) { /* ignore */ }
  }
}

export function toggleAuthorHidden(key) {
  const next = new Set(state.hiddenAuthors);
  if (next.has(key)) next.delete(key); else next.add(key);
  setHiddenAuthors(next);
}

export function subscribeAuthorFilter(fn) {
  state.listeners.add(fn);
  return () => state.listeners.delete(fn);
}

// Kanonik anahtar — Notlar sekmesi ile aynı mantık.
export function authorCanonicalKey({ authorUserId, authorName }) {
  if (authorUserId) return `u:${authorUserId}`;
  return `n:${(authorName || 'Anonim').toLowerCase().trim()}`;
}

// Sahnedeki tüm callout objelerine (userData.type === 'callout' veya
// userData._callout === true) yazarın kanonik anahtarına göre visibility uygula.
export function applyAuthorFilterToScene(scene) {
  if (!scene) return;
  const hidden = state.hiddenAuthors;
  scene.traverse(obj => {
    const ud = obj.userData || {};
    if (ud.type !== 'callout' && ud._callout !== true) return;
    const k = authorCanonicalKey({
      authorUserId: ud.authorUserId,
      authorName: ud.authorName,
    });
    obj.visible = !hidden.has(k);
  });
}

// Tek bir callout objesi (yeni eklendiğinde) için visibility uygula.
export function applyAuthorFilterToObject(obj) {
  if (!obj) return;
  const ud = obj.userData || {};
  if (ud.type !== 'callout' && ud._callout !== true) return;
  const hidden = state.hiddenAuthors;
  const k = authorCanonicalKey({
    authorUserId: ud.authorUserId,
    authorName: ud.authorName,
  });
  obj.visible = !hidden.has(k);
}
